import styled from 'styled-components';

export const StyledButton = styled.button`
    height: 30px;
`;